import * as FC from "@fluentui/react-components";
import { useCommonStyles } from "../../style_util";
import { useSearchInput } from "../../components/search_input";
import { SimpleGrid, useSimpleGrid } from "../../components/simple_grid";
import { FieldItemDef } from "../../services/field_item_service";
import { useContext, useState, useEffect } from "react";
import { filterToCondition, idString, mapPart } from "../../db_utils";
import { LabelValue } from "../../components/label_value";
import { toDateString, toDateTimeString } from "../../date_utils";
import { TurbineDef, listTurbines } from "../../services/turbine_service";
import { Context } from "../../context";
import { useDrawer } from "../../components/use_drawer";
import { ViewFrames } from "./view_frames";
import { getCurrentFieldFromStorage } from "../../workspace";

console.log("🚀 field.js module loaded");

const useStyles = FC.makeStyles({});

export const field_item_searchable_columns = ["name"];
const listFieldItem = async (db, filter) => {
    let query = `select *, 
      count((select * from turbine where field_item=$parent.id)) as turbine_count, 
      count((select * from task where $parent.id INSIDE turbines.*.field_item fetch turbines.*)) as task_count, 
      (select * from turbine where field_item=$parent.id) as turbines,
      (select * from task where $parent.id INSIDE turbines.*.field_item order by updated_at desc limit 1)[0] as recent_task
    from field_item`;
    let vars = {};
    let condition = filterToCondition(
        field_item_searchable_columns,
        filter,
        vars,
    );
    if (condition) {
        query += ` WHERE ${condition}`;
    }
    query += " fetch turbines.*,turbines.*.model,turbines.*.model.manu";
    let [rets] = await db.query(query, vars);
    return rets;
};

const fetchTurbineDetail = async (db, turbineId) => {
    let query = `select *, 
       (select * from leaf where $parent.id = turbine) as leafs, 
       (select * from task where $parent.id INSIDE turbines.*)[0] as recent_task, 
       (select * from defection where from_frame.from_raw.leaf.turbine = $parent.id fetch from_frame,from_frame.from_raw) as defections 
   from ONLY type::thing($turbineId)
   fetch field_item,model,leafs.*.model,recent_task.owner_creater,recent_task.owner_checker,recent_task.owner_rechecker
   `;
    let vars = {
        turbineId,
    };
    let [rets] = await db.query(query, vars);
    return rets;
};

// const FieldList = ({ onSelect }) => {
//     const { refresh, SearchInput, items, db } = useSimpleGrid({
//         listItems: listFieldItem,
//     });
//     const [selectedItems, setSelectedItems] = useState([]);
//     useEffect(() => {
//         if (items && items.length > 0) {
//             let item = items[0];
//             setSelectedItems([item.id]);
//             onSelect(items[0]);
//         } else {
//             setSelectedItems([]);
//         }
//     }, [items]);
//     const columns = [FieldItemDef.createTableColumn("name")];
//     return (
//         <div className="flex flex-col gap-2">
//             <FC.Label>风场列表({items.length})</FC.Label>
//             <SearchInput style={{ flex: "none" }} appearance="underline" />
//             {items && items.length > 0 && (
//                 <SimpleGrid
//                     items={items}
//                     columns={columns}
//                     noHeader
//                     subtleSelection={true}
//                     getRowId={FieldItemDef.getRowId}
//                     selectionMode="single"
//                     selectionAppearance="none"
//                     selectedItems={selectedItems}
//                     onSelectionChange={(evt, data) => {
//                         let item = Array.from(data.selectedItems)[0];
//                         item = items.find((it) => idString(it.id) === item);
//                         setSelectedItems([item.id]);
//                         onSelect(item);
//                     }}
//                 />
//             )}
//         </div>
//     );
// };
const ShowFieldItem = ({ field, onSelectTurbine }) => {
    const columns = [
        TurbineDef.createTableColumn("seq"),
        TurbineDef.createTableColumn("name"),
        // FC.createTableColumn({
        //     columnId: "model.manu.name",
        //     renderHeaderCell: () => {
        //         return <FC.TableCellLayout>厂商</FC.TableCellLayout>;
        //     },
        //     renderCell: (item) => {
        //         return (
        //             <FC.TableCellLayout>
        //                 {item?.model?.manu?.name}
        //             </FC.TableCellLayout>
        //         );
        //     },
        // }),
        TurbineDef.createTableColumn("model"),
        FC.createTableColumn({
            columnId: "model.power",
            renderHeaderCell: () => {
                return <FC.TableCellLayout>功率(MW)</FC.TableCellLayout>;
            },
            renderCell: (item) => {
                return (
                    <FC.TableCellLayout>
                        {item?.model?.power}
                    </FC.TableCellLayout>
                );
            },
        }),

        TurbineDef.createTableColumn("installed_at"),
        TurbineDef.createTableColumn("updated_at"),
        TurbineDef.createOpsColumn({
            renderCell(item) {
                return (
                    <FC.TableCellLayout>
                        <FC.Button
                            appearance="subtle"
                            onClick={() => {
                                onSelectTurbine(item);
                            }}
                        >
                            巡检数据
                        </FC.Button>
                    </FC.TableCellLayout>
                );
            },
        }),
    ];
    if (!field) {
        return <div className="flex flex-1 bg-grey-200"></div>;
    }
    return (
        <div className="flex flex-col flex-1 gap-8 p-8">
            <h3 className="text-xl font-bold">{field.name}</h3>
            <div className="flex flex-row gap-4">
                <div
                    className="flex-1 grid grid-cols-4"
                    style={{ gridTemplateColumns: "auto 1fr auto 1fr", gap: 8 }}
                >
                    {FieldItemDef.label_value(field, "seq")}
                    {FieldItemDef.label_value(field, "typ")}
                    <LabelValue label="风机总数:" value={field.turbines?.length || 0} />
                    <LabelValue label="装机容量:" value={`${field.power}MW`} />
                    <LabelValue label="风场地址:" value={field.address} />
                    <LabelValue
                        label="建设时间:"
                        value={toDateString(field.built_at)}
                    />
                    <LabelValue label="经度:" value={field.longitude} />
                    <LabelValue label="纬度:" value={field.latitude} />
                    {FieldItemDef.label_value(field, "contact")}
                    {FieldItemDef.label_value(field, "contact_phone")}
                    <LabelValue label="巡检次数:" value={field.task_count} />
                    <LabelValue
                        label="巡检时间:"
                        value={toDateString(field.recent_task?.check_at)}
                    />
                </div>
                <img src="/image1.png" className="invisible" />
            </div>
            <SimpleGrid
                items={field.turbines || []}
                columns={columns}
                getRowId={(item) => idString(item.id)}
            />
        </div>
    );
};

const getFrameCountByTaskLeafPart = async (db, taskId, leafId, part) => {
    if (!taskId || !leafId || !part) {
        return null;
    }
    let query = `count((select * from frame_data where from_raw.task=type::thing($taskId) and from_raw.leaf=type::thing($leafId) and from_raw.part=$part))`;
    let vars = {
        taskId,
        leafId,
        part,
    };
    let [rets] = await db.query(query, vars);
    return rets;
};

export const LeafPartWithDefection = ({
    leaf,
    part,
    taskId,
    defections,
    onClickDefection,
}) => {
    const { apiClient } = useContext(Context);
    const [frameCount, setFrameCount] = useState(null);
    const partName = mapPart[part]?.text;
    const loadData = async () => {
        // TODO: Implement frame count API endpoint
        // For now, just set to 0
        setFrameCount(0);
    };
    useEffect(() => {
        if (!apiClient) {
            return;
        }
        loadData();
    }, [apiClient]);
    const leafLength = leaf?.model?.length;
    const defs =
        (leafLength &&
            defections.filter(
                (defection) =>
                    defection.from_frame?.distance &&
                    defection.from_frame?.distance >= 0 &&
                    defection.from_frame?.distance <= leafLength,
            )) ||
        [];
    const defectionRect = (defection) => {
        // const cx = parseInt(defection.x + defection.width / 2);
        // const cy = parseInt(defection.y + defection.height / 2);
        const x = defection.x * 28;
        const w = Math.max(defection.width * 28, 6);
        // const x = 0;
        // const w = 28;
        const y = (defection?.from_frame?.distance / leafLength) * 428;
        const h = 8;
        return { x, y, w, h };
    };
    return (
        <div className="flex flex-col gap-2 items-center">
            <div>{partName}</div>
            <div>
                {defections.length}
                {(frameCount && `/${frameCount}`) || `/0`}
            </div>
            <div className="relative">
                <svg
                    width="28"
                    height="428"
                    viewBox="0 0 28 428"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ zoom: 0.8 }}
                >
                    <path
                        d="M12.6054 0V32.0111L0 67.2102L11.4389 394.166L15.9551 426.518C16.0315 427.065 16.5368 427.446 17.0838 427.37C17.5653 427.302 17.9288 426.899 17.945 426.413L28 125.282V0H12.6054Z"
                        fill="url(#paint0_linear_40468_22852)"
                        fillOpacity="0.75"
                    />
                    {defs.map((defection) => {
                        const rect = defectionRect(defection);
                        return (
                            <rect
                                key={idString(defection?.id)}
                                fill="#f00"
                                style={{
                                    cursor:
                                        (onClickDefection && "pointer") ||
                                        "auto",
                                }}
                                x={rect.x}
                                y={rect.y}
                                width={rect.w}
                                height={rect.h}
                                onClick={() => {
                                    if (onClickDefection) {
                                        onClickDefection(defection);
                                    }
                                }}
                            />
                        );
                    })}
                    <defs>
                        <linearGradient
                            id="paint0_linear_40468_22852"
                            x1="4797.09"
                            y1="21369"
                            x2="-2570.63"
                            y2="21369"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="#717171" />
                            <stop offset="0.471812" stopColor="white" />
                            <stop offset="1" stopColor="#717171" />
                        </linearGradient>
                    </defs>
                </svg>
            </div>
        </div>
    );
};

const LeafWithDefection = ({ leaf, taskId, defections, onClickDefection }) => {
    let leafPart = { null: "未挂载", A: "A", B: "B", C: "C", D: "D" };
    return (
        <div className="gap-4 flex flex-col">
            <h3 className="font-bold text-center">
                叶片{leafPart[idString(leaf.attach_id)] || "未挂载"} (
                {leaf?.seq})
            </h3>
            <div className="flex flex-row gap-2">
                <LeafPartWithDefection
                    leaf={leaf}
                    taskId={taskId}
                    part="front"
                    key="前缘"
                    defections={defections.filter(
                        (it) =>
                            it?.from_frame?.from_raw?.part == "front" &&
                            idString(it?.from_frame?.from_raw?.leaf) ==
                                idString(leaf.id),
                    )}
                    onClickDefection={onClickDefection}
                />
                <LeafPartWithDefection
                    leaf={leaf}
                    taskId={taskId}
                    part="belly"
                    key="腹板"
                    defections={defections.filter(
                        (it) =>
                            it?.from_frame?.from_raw?.part == "belly" &&
                            idString(it?.from_frame?.from_raw?.leaf) ==
                                idString(leaf.id),
                    )}
                    onClickDefection={onClickDefection}
                />
                <LeafPartWithDefection
                    leaf={leaf}
                    taskId={taskId}
                    part="back"
                    key="后缘"
                    defections={defections.filter(
                        (it) =>
                            it?.from_frame?.from_raw?.part == "back" &&
                            idString(it?.from_frame?.from_raw?.leaf) ==
                                idString(leaf.id),
                    )}
                    onClickDefection={onClickDefection}
                />
            </div>
        </div>
    );
};

const TurbineDetail = ({ turbine }) => {
    const [defectionId, setDefectionId] = useState(null);
    const onClickDefection = (defection) => {
        setDefectionId(defection?.id);
        // window.open(
        //     `/datacenter/viewframes?defectionId=${defection.id}`,
        //     "_blank"
        // );
    };
    return (
        <div className="flex flex-col">
            <div className="flex flex-row flex-1 gap-8 py-8 justify-center justify-items-center">
                <div className="flex flex-row gap-12">
                    {(turbine?.leafs || []).map((leaf) => (
                        <LeafWithDefection
                            leaf={leaf}
                            taskId={turbine.recent_task?.id}
                            key={idString(leaf?.id)}
                            defections={(turbine.defections || []).filter(
                                (defection) =>
                                    idString(
                                        defection?.from_frame?.from_raw?.leaf,
                                    ) == idString(leaf?.id),
                            )}
                            onClickDefection={onClickDefection}
                        />
                    ))}
                </div>
                <div className="">
                    <h4 className="text-base font-bold mb-4 ">基本信息</h4>
                    <div className="grid grid-cols-[auto_1fr] gap-4">
                        <LabelValue label="风机编号:" value={turbine.seq} />
                        <LabelValue label="风机名称:" value={turbine.name} />
                        <LabelValue
                            label="风场名称:"
                            value={turbine.field_item?.name}
                        />
                        <LabelValue
                            label="任务编号:"
                            value={turbine.recent_task?.seq}
                        />
                        <LabelValue
                            label="任务名称:"
                            value={turbine.recent_task?.name}
                        />
                        <LabelValue
                            label="创建人员:"
                            value={turbine?.recent_task?.owner_creater?.name}
                        />
                        <LabelValue
                            label="巡检人员:"
                            value={turbine?.recent_task?.owner_checker?.name}
                        />
                        <LabelValue
                            label="巡检时间:"
                            value={toDateTimeString(
                                turbine?.recent_task?.check_at,
                            )}
                        />
                        <LabelValue
                            label="复核人员:"
                            value={turbine?.recent_task?.owner_rechecker?.name}
                        />
                        <LabelValue
                            label="复核时间:"
                            value={toDateTimeString(
                                turbine?.recent_task?.recheck_at,
                            )}
                        />
                        <FC.Link
                            href={`/datacenter/viewframes?taskId=${idString(
                                turbine?.recent_task?.id,
                            )}&turbineId=${idString(turbine?.id)}`}
                            target="_blank"
                        >
                            查看全部缺陷
                        </FC.Link>
                    </div>
                </div>
            </div>
            <div>
                {defectionId && (
                    <div className="p-4 border border-[#ccc]">
                        <ViewFrames
                            defectionId={defectionId}
                            key={idString(defectionId)}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export const DatacenterFieldManagement = () => {
    console.log("🟢 DatacenterFieldManagement component loading...");
    
    const { openDrawer, closeDrawer, drawer } = useDrawer({
        style: { width: 1000 },
        position: "left",
    });
    
    console.log("🟡 About to get Context...");
    const { apiClient, currentField } = useContext(Context);
    console.log("🟡 Got Context:", { apiClient: !!apiClient, currentField });
    
    const [field, setField] = useState(null);
    const [turbine, setTurbine] = useState(null);
    
    // Debug logging
    console.log("🔵 DatacenterFieldManagement rendered with:", {
        apiClient: !!apiClient,
        currentField: currentField,
        contextKeys: Object.keys(useContext(Context))
    });
    const init = async () => {
        console.log("init() called with:", { 
            apiClient: !!apiClient, 
            currentField: currentField,
            apiClientType: typeof apiClient,
            currentFieldType: typeof currentField
        });
        
        if (!apiClient) {
            console.warn("No apiClient available");
            return;
        }
        
        if (!currentField) {
            console.warn("No currentField available");
            return;
        }
        
        try {
            // Get the field ID - currentField might be an object or an ID
            const fieldId = currentField.id || currentField;
            
            console.log("About to make API calls for fieldId:", fieldId);
            
            // Get current field details from API
            console.log("Making API call to:", `/fielditem/${fieldId}`);
            const fieldResponse = await apiClient.get(`/fielditem/${fieldId}`);
            const fieldData = fieldResponse.data;
            
            // Get turbines for this field
            console.log("Making API call to list turbines for fieldId:", fieldId);
            const turbines = await listTurbines(apiClient, fieldId);
            
            fieldData.turbines = turbines;
            setField(fieldData);
            console.log("Successfully loaded field data:", fieldData);
        } catch (error) {
            console.error("Error loading field data:", error);
        }
    };
    useEffect(() => {
        init();
    }, [apiClient, currentField]);

    const onSelectTurbine = async (_turbine) => {
        setTurbine(_turbine);
        try {
            // For now, just show the turbine data we have
            // TODO: Implement fetchTurbineDetail API endpoint
            openDrawer({
                header: "巡检信息视图",
                body: <TurbineDetail turbine={_turbine} />,
            });
        } catch (error) {
            console.error("Error loading turbine details:", error);
        }
    };

    const commonStyles = useCommonStyles();
    
    console.log("🟢 About to render DatacenterFieldManagement");
    
    // Simple test render first
    return (
        <div className={FC.mergeClasses("flex flex-row gap-2 p-2 flex-1")}>
            <div style={{ padding: '20px', border: '2px solid red' }}>
                <h1>🚀 风场数据页面已加载</h1>
                <p>apiClient: {apiClient ? '✅ 已连接' : '❌ 未连接'}</p>
                <p>currentField: {currentField ? '✅ 已设置' : '❌ 未设置'}</p>
                <p>currentField value: {JSON.stringify(currentField)}</p>
            </div>
            <ShowFieldItem field={field} onSelectTurbine={onSelectTurbine} />
            {drawer}
        </div>
    );
};
